import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import vis, { Timeline } from 'vis';
import moment from 'moment';
import {DateTimeService} from '../../../../../../services/date-time.service';

@Component({
  selector: 'app-history-timeline',
  templateUrl: './history-timeline.component.html',
  styleUrls: ['./history-timeline.component.css']
})
export class HistoryTimelineComponent implements OnInit, AfterViewInit {

  @Input() timelineEvents;
  @Input() pageInstanceHistoryDetail;
  @Output() onEventClick: EventEmitter<any> = new EventEmitter();
  events;
  instanceDuration;
  pageDuration;

  @ViewChild('visElement',  { static: false }) visElement: ElementRef;


  constructor(
    private dateTimeService: DateTimeService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    //isso é necessário para aparecer a descrição da data em português na linha do tempo
    moment.locale('pt-br');
    this.applyEventTimestamps(this.timelineEvents);
    this.applyPageDuration(this.pageInstanceHistoryDetail);
    this.applyInstanceDuration();
  }

  ngAfterViewInit(): void {
    let dataSet = [];
    let index = 0;

    let lastVersion=0;
    let groups = [];
    let lastEventIsOverride;
    this.events.forEach(ev => {
      if (ev.version != lastVersion){
        groups.push({
          id: ev.version,
          content: `Versão ${ev.version}`
        });
        lastVersion = ev.version;
      }
      if (ev.eventType == 1) { //StateChange
        if (lastEventIsOverride){
          lastEventIsOverride = false;
        } else {
          dataSet.push({
            id: index,
            content: "",
            type:"point",
            style:"cursor: pointer",
            start: ev.localStateLifeCycleModifyDate,
            title: "Transição para o estado " + ev.stateName + '<br/>' + this.dateTimeService.toLocalStringDateTime(ev.stateLifeCycleModifyDate),
            group: ev.version
          });
        }

        index++;
      }else if (ev.eventType == 2) { //Override
        lastEventIsOverride = true;
        dataSet.push({
          id: index,
          content: "",
          type:"point",
          style: "background-color: #97b0f8;cursor: pointer;border-radius: 4px;border-width: 2.9px;border-style: solid;border-color: #e08393;width:20px;height:20.4px",
          start: ev.localStateLifeCycleModifyDate,
          title: "Imposição para o estado " + ev.stateName + '<br/>' + this.dateTimeService.toLocalStringDateTime(ev.stateLifeCycleModifyDate),
          group: ev.version
        });
        index++;
      }
    });
    dataSet.push({
      id: "SG_1_1",
      type: "background",
      start: this.pageDuration.from,
      end: this.pageDuration.to,
      // subgroup: "sg_3",
      // subgroupOrder: 0,
      className: "positive",
      group: this.pageDuration.version,
    });

    let items = new vis.DataSet(dataSet);

    // Configuration for the Timeline
    var options = {
      editable: false,
      margin: {
        item: 20,
        axis: 40,
      },
      maxHeight: 400,
      max: this.instanceDuration.from,
      min: this.instanceDuration.to,
      moment: moment
    };

    // Create a Timeline
    var timeline = new vis.Timeline(this.visElement.nativeElement, items, new vis.DataSet(groups), options);

    index = 0;

    timeline.on("click", (properties) => {
      if (this.onEventClick && this.events[properties.item]){
        this.onEventClick.emit(this.events[properties.item]);
      }
    });
  }


  applyEventTimestamps(events){
    let previousEventDate = undefined;

    events.forEach(e => {
      e.localStateLifeCycleModifyDate = this.dateTimeService.tolocalDateTime(e.stateLifeCycleModifyDate);
      if (previousEventDate && e.stateLifeCycleModifyDate < previousEventDate) {
        e.timestamp = previousEventDate;
      } else {
        e.timestamp = e.stateLifeCycleModifyDate;
      }
      previousEventDate = e.stateLifeCycleModifyDate;
    })
  }

  applyPageDuration(page) {
    let minDate, maxDate, lastState, lastInitialStateLifeCycle, maxStateLifeCycle;
    page.stateLifeCycles.forEach(lifeCycle => {
      if (lastState != lifeCycle.stateId)
      {
        lastState = lifeCycle.stateId;
        lastInitialStateLifeCycle = lifeCycle;
      }

      if (!minDate || lifeCycle.stateLifeCycleModifyDate < minDate) {
        minDate = lifeCycle.stateLifeCycleModifyDate;
      }
      if (!maxDate || lifeCycle.stateLifeCycleModifyDate > maxDate) {
        maxStateLifeCycle = lifeCycle;
        maxDate = lifeCycle.stateLifeCycleModifyDate;
      }
    })

    if (minDate && maxDate) {
      if (lastInitialStateLifeCycle.executionOrder < maxStateLifeCycle.executionOrder) {
        maxDate = lastInitialStateLifeCycle.stateLifeCycleModifyDate;
      }
      this.pageDuration = {
        from: this.dateTimeService.tolocalDateTime(minDate),
        to: this.dateTimeService.tolocalDateTime(maxDate),
        version: page.businessProcessVersion
      };
    }
  };

  applyInstanceDuration(){
    this.events = [];
    let minDate = new Date(2999, 11, 31);
    let maxDate = new Date(1900, 0, 1);

    this.timelineEvents.forEach(evt => {
      if (evt.timestamp < minDate) {
        minDate = evt.timestamp;
      }
      if (evt.timestamp > maxDate) {
        maxDate = evt.timestamp;
      }

      this.events.push(evt);
    })

    this.instanceDuration = {
      from: this.dateTimeService.tolocalDateTime(minDate), // Início do 1º ciclo de vida do primeiro estado visível pelo usuário na instância
      to: this.dateTimeService.tolocalDateTime(maxDate) // Fim do último ciclo de vida do último estado visível pelo usuário na instância
    };
  }
}
